
import Library from '../utility/Library';
import Companion from './Companion';
import User from '../../User';

const mystery_articles = {
	"relic": {
		"key": -1,
		"name": "Mysterious equipment",
		"img": "https://moa-pull.b-cdn.net/assets/ui/giftrelic.png",
		"effect": "This box contains an unknown equipment."
	},
	"item": {
		"key": -1,
		"name": "Mysterious item",
		"img": "https://moa-pull.b-cdn.net/assets/ui/giftitem.png",
		"effect": "This box contains an unknown item."
	},
	"card": {
		"key": -1,
		"name": "Mysterious card",
		"img": "https://moa-pull.b-cdn.net/assets/ui/giftcard.png",
		"effect": "This box contains an unknown card.",
		"type": "item"
	}
}

const model = {
	"type": "shop",
	"articles": {
		"cards": 4,
		"potions": 4,
		"relics": 2
	},
	"merchant": "Mezuri",
	"img": "https://moa-pull.b-cdn.net/assets/events/mezuri.png",
	"name": "Mezuri's den",
	"description": "A sanctuary in the shadows. Spend your gold wisely and prepare for the challenges ahead."
}

const GIFT_CHANCES = {
	"card": 0.35,
	"potion": 0.32,
	"relic": 0.18,
	"seed": 0.08,
	"berry": 0.07,
	"paws": 0.00
}

const SLOTS = {
	"seed": 0.065,
	"berry": 0.065,
	"coin": 0.0325,
	"relic": 0.0325,
	"potion": 0.065
}

export default class Shop {

	constructor (run, script={}) {

		this.run = run;
		this.mezuri = script.mezuri;
		this.single = script.single;
		this.articles = [];
		this.run.notify('newshop', this, run);
	}

	get name () {

		return model.name;
	}

	get description () {

		return model.description;
	}

	addSlotMachine () {

		this.slotMachine = [ "coin", "coin", "coin" ];
		this.run.notify('slotmachine', this);
	}

	runSlots () {

		const totalChance = Object.values(SLOTS).reduce((a, b) => a + b, 0);
		let roll = Math.random();
		let result = null;
	    if (roll < totalChance) {
		    let cumulative = 0;
		    for (const [key, weight] of Object.entries(SLOTS)) {
		        cumulative += weight;
		        if (roll <= cumulative) {
		            result = key;
		            break;
		        }
		    }
		    this.slotMachine = [result, result, result];
	    }
	    else {
	    	const slotKeys = Object.keys(SLOTS);
		    do {
		        this.slotMachine = [
		            slotKeys[Math.floor(Math.random() * slotKeys.length)],
		            slotKeys[Math.floor(Math.random() * slotKeys.length)],
		            slotKeys[Math.floor(Math.random() * slotKeys.length)]
		        ];
		    } while (this.slotMachine[0] === this.slotMachine[1] && this.slotMachine[1] === this.slotMachine[2]);
	    }
		this.run.notify('runslots', this, this.slotMachine);

		if (result) {

			const rewardSlot = this.articles[1];
			rewardSlot.sold = false;
			switch (result) {
			case "seed":
			case "berry":
			case "coin":
				rewardSlot.type = result;
				break;
			case "relic":
				let relic = this.run.generateRelic();
				rewardSlot.type = "relic";
				rewardSlot.value = relic;
				break;
			case "potion":
				let potions = Object.values(Library.potions);
				potions = potions.filter(potion => potion.rarity && (!potion.rank || this.run.power >= potion.rank) && (!potion.champion || potion.champion === this.run.champion.model.key || (Array.isArray(potion.champion) && potion.champion.includes(this.run.champion.model.key))))
				let potion = Library.upgradeItem(potions[Math.floor(Math.random() * potions.length)], this.run.power);
				rewardSlot.type = "potion";
				rewardSlot.value = potion;
				break;
			case "remove":
				rewardSlot.type = "remove";
				rewardSlot.value = 1;
				break;
			case "insight":
				rewardSlot.type = "insight";
				rewardSlot.value = 2;
				break;
			default: break;
			}

			this.run.notify('shopchangearticle', this, 1, rewardSlot);
		}
	}

    getLists (treasurepool=false) {

	    const cards = Object.values(Library.cards)
	        .filter(c =>
	            c.champion === this.run.champion.model.key &&
	            c.rarity && !c.token &&
	            (!c.level || c.level <= User.data.level)
	        );

        let potions = Object.values(Library.potions)
            .filter(item =>
				item.rarity && !item.noshop && (!item.rank || this.run.power >= item.rank) &&
                (!item.champion || item.champion === this.run.champion.key || (Array.isArray(item.champion) && item.champion.includes(this.run.champion.model.key)))
            )
			.map(item => Library.upgradeItem(item, this.run.power));
        let relics = Object.values(Library.relics)
            .filter(relic =>
                ((treasurepool && relic.pool === "treasure") || relic.pool === "shop") &&
                (!relic.champion || relic.champion === this.run.champion.key) &&
                (!relic.rank || this.run.power >= relic.rank)
            )
            .filter(relic =>
                !this.run.champion.relics.some(r => r.key === relic.key || (r.conflict && r.conflict.includes(relic.key)))
            )
			.map(relic => Library.upgradeItem(relic, this.run.power));
        let companions = Object.values(Library.companions)
            .filter(item =>
                !item.champion || item.champion === this.run.champion.key || (Array.isArray(item.champion) && item.champion.includes(this.run.champion.model.key))
            );

        return { cards, potions, relics, companions }
    }

    getRandomGift () {

		const rand = Math.random();
		let cumulative = 0;
		for (const [key, chance] of Object.entries(GIFT_CHANCES)) {
			cumulative += chance;
			if (rand < cumulative) return key;
		}
	}

	computePrice (price) {

		if (typeof price === "number" && !isNaN(price))
			return price;

		switch (price) {
		case "floor": return this.run.floor;
		default: break;
		}

		switch (price && price.op) {
		case "times": return price.values.reduce((acc, x) => acc * this.computePrice(x), 1);
		case "plus": return price.values.reduce((acc, x) => acc + this.computePrice(x), 0);
		default: return 0;
		}

		return 0;
	}

	fill(articles) {

	    this.articles = [];

	    const basePriceFactors = {
	        card: 32,
	        potion: 20,
	        relic: 72,
	        companion: 100
	    };

	    const getAdjustedPrice = (value, type) => {
	        let rarityMultiplier = value.rarity || 1;
	        // Special handling for card rarity 3
	        if (type === 'card' && rarityMultiplier === 3) {
	            rarityMultiplier = 4;
	        } else if (type === 'relic' && value.pool === "treasure") {
	        	rarityMultiplier = 1.66;
	        }
	        const basePrice = basePriceFactors[type] * rarityMultiplier;
	        const adjustment = (0.8 + Math.random() * 0.7);
	        return Math.ceil(basePrice * adjustment);
	    };

	    const getWeightedArray = (items, type) => {

	        return items.flatMap(item => {
	            let weight = 4;
	            if (item.rarity === 2) weight = 2;
	            else if (item.rarity === 3) weight = 1;
	            return Array(weight).fill(item);
	        });
	    };

	    const addArticles = (type, list, count, currency, set_price=null) => {

	    	const baseCurrency = currency;
	    	
	        for (let i = 0; i < count; i++) {
	            // Filter out items already chosen
	            let filteredList = list.filter(item => !this.articles.some(a => a.type === type && a.value.key === item.key));

	            // Weighted selection for items, direct random for cards
	            let chosen;
	            if (type === 'potion') {
	                const weighted = getWeightedArray(filteredList, type);
	                chosen = weighted[Math.floor(Math.random() * weighted.length)];
	            } else {
	                chosen = filteredList[Math.floor(Math.random() * filteredList.length)];
	            }

	            if (!chosen) continue;

	            let price = set_price || getAdjustedPrice(chosen, type);
	            if (baseCurrency === "free") {
	            	currency = null;
	            	price = null;
	            }
	            if (type === "card")
	            	chosen = this.run.getUpgradedCard(chosen);
	            this.articles.push({ value: chosen, price, type, currency });

	            if (type === "potion")
					User.learn("potions", chosen.key);
	            else if (type === "relic")
					User.learn("relics", chosen.key);
	            else if (type === "card")
					User.learn("cards", chosen.key);
	        }
	    };

	    const lists = this.getLists();
	    const cardlist = lists.cards;
	    const potions = lists.potions;
	    const relics = lists.relics;
	    const companions = lists.companions;
	    const championRelics = Object.values(Library.relics)
            .filter(relic =>
                (relic.pool === "treasure") && relic.champion === this.run.champion.key
            )
            .filter(relic =>
                !this.run.champion.relics.some(r => r.key === relic.key || (r.conflict && r.conflict.includes(relic.key)))
            )
			.map(relic => Library.upgradeItem(relic, this.run.power));

	    articles.forEach(entry => {
	        const { type } = entry;
	        switch (type) {
	            case 'uncommons':
	            case 'commons':
	            case 'cards': {
	            	let entrycardlist = cardlist;
	            	if (type === "commons")
	            		entrycardlist = cardlist.filter(c => c.rarity === 1);
	            	else if (type === "uncommons")
	            		entrycardlist = cardlist.filter(c => c.rarity === 2);
	            	if (entry.value)
	            		entrycardlist = entry.value.map(no => Library.getCard(no)).map(card => {
	            			if (!card.upgrades || !card.upgrades[0].rank)
	            				return card;
	            			let upgrade = null;
	            			for (let i = 0; i < card.upgrades.length && card.upgrades[0].rank <= this.run.power; i++)
	            				upgrade = card.upgrades[0];
	            			if (!upgrade)
	            				return card;
	            			else
	            				return Object.assign({}, card, upgrade);
	            		});
	                addArticles('card', entrycardlist, entry.count, entry.currency || 'gold', this.computePrice(entry.price));
	                break;
	            }

	            case 'potions': {
	            	let entryitemlist = potions;
	            	if (entry.value)
                    entryitemlist = entry.value.map(no => Library.upgradeItem(Library.getPotion(no), this.run.power));
	                addArticles('potion', entryitemlist, entry.count, entry.currency || 'gold', this.computePrice(entry.price));
	                break;
	            }

	            case 'relics': {
	            	let entryreliclist = relics;
	            	if (entry.value)
	            		entryreliclist = entry.value.filter(no => !this.run.champion.relics.some(r => r.key === no)).map(no => Library.upgradeItem(Library.getRelic(no), this.run.power));
	                addArticles('relic', entryreliclist, entry.count, entry.currency || 'gold', this.computePrice(entry.price));
	                break;
	            }

	            case 'championrelics': {
	            	let entryreliclist = championRelics;
	            	if (entry.value)
	            		entryreliclist = entry.value.map(no => Library.upgradeItem(Library.getRelic(no), this.run.power));
	                addArticles('relic', entryreliclist, entry.count, entry.currency || 'gold', this.computePrice(entry.price));
	                break;
	            }

	            case 'companions': {
	            	let entrycompanionlist = companions.filter(c => !this.run.companion || this.run.companion.model.key !== c.key);
	            	if (entry.value)
	            		entrycompanionlist = entry.value.map(no => Library.getCompanion(no));
	                addArticles('companion', entrycompanionlist, entry.count, entry.currency || 'paws', this.computePrice(entry.price || 2));
	                break;
	            }

	            case 'switchcompanion': {
	                this.articles.push({
	                    price: this.computePrice(entry.price),
	                    type: 'switchcompanion',
	                    currency: entry.currency || 'paws',
	                    infinite: entry.infinite,
	                    scaling: entry.scaling
	                });
	                break;
	            }

	            case 'health': {
	                this.articles.push({
	                    value: entry.value,
	                    price: this.computePrice(entry.price),
	                    type: 'health',
	                    currency: entry.currency || 'gold',
	                    infinite: entry.infinite,
	                    scaling: entry.scaling
	                });
	                break;
	            }

	            case 'gold': {
	                this.articles.push({
	                    value: entry.value,
	                    price: this.computePrice(entry.price),
	                    type: 'gold',
	                    currency: entry.currency || 'gold',
	                    infinite: entry.infinite,
	                    scaling: entry.scaling
	                });
	                break;
	            }

	            case 'seed': {
	                this.articles.push({
	                    price: this.mezuri ? (10 + 20 * this.run.floor + 0 * this.run.seedCountShop) : this.computePrice(entry.price),
	                    type: 'seed',
	                    currency: entry.currency || 'gold',
	                    infinite: entry.infinite,
	                    scaling: entry.scaling
	                });
	                break;
	            }

	            case 'insight': {
	                this.articles.push({
	                    price: this.mezuri ? (10 + 20 * this.run.floor) : this.computePrice(entry.price),
	                    value: 1,
	                    type: 'insight',
	                    currency: entry.currency || 'gold',
	                    infinite: entry.infinite,
	                    scaling: entry.scaling
	                });
	                break;
	            }

	            case 'berry': {
	                this.articles.push({
	                    price: this.mezuri ? 10 + 20 * this.run.floor : this.computePrice(entry.price),
	                    type: 'berry',
	                    currency: entry.currency || 'gold',
	                    infinite: entry.infinite,
	                    scaling: entry.scaling
	                });
	                break;
	            }

	            case 'coin': {
	                this.articles.push({
	                    price: this.computePrice(entry.price),
	                    type: 'coin',
	                    currency: entry.currency || 'gold',
	                    infinite: entry.infinite,
	                    scaling: entry.scaling
	                });
	                break;
	            }

	            case 'paws': {
	                this.articles.push({
	                    price: this.computePrice(entry.price),
	                    type: 'paws',
	                    currency: entry.currency || 'gold',
	                    infinite: entry.infinite,
	                    scaling: entry.scaling
	                });
	                break;
	            }

	            case 'remove': {
	                this.articles.push({
	                    price: (this.mezuri ? (10 + 20 * this.run.floor + 20 * this.run.removeCountShop) : this.computePrice(entry.price)) * ((entry.currency || 'gold') === 'gold' && this.run.champion.getPassive("cardremovalgold") ? this.run.champion.getPassive("cardremovalgold") : 1),
	                    type: 'remove',
	                    currency: entry.currency || 'gold',
	                    infinite: entry.infinite,
	                    scaling: entry.scaling
	                });
	                break;
	            }

	            case 'cleanse': {
	                this.articles.push({
	                    price: this.computePrice(entry.price),
	                    type: 'cleanse',
	                    currency: entry.currency || 'gold',
	                    infinite: entry.infinite,
	                    scaling: entry.scaling
	                });
	                break;
	            }

	            case 'empty': {
	                this.articles.push({
	                    price: 0,
	                    type: 'empty',
	                    currency: entry.currency || 'gold',
	                    infinite: entry.infinite,
	                    scaling: entry.scaling,
	                    sold: true
	                });
	                break;
	            }

	            case 'special': {
	                this.articles.push({
	                    price: this.computePrice(entry.price),
	                    type: 'special',
	                    currency: entry.currency || 'gold',
	                    infinite: entry.infinite,
	                    scaling: entry.scaling
	                });
	                break;
	            }

	            case 'randompotion': {
	                this.articles.push({
	                    price: this.computePrice(entry.price),
	                    type: 'randompotion',
	                    currency: entry.currency || 'gold',
	                    infinite: entry.infinite,
	                    scaling: entry.scaling
	                });
	                break;
	            }

	            case 'gift': {
		        	for (let i = 0; i < entry.count; i++) {
		                this.articles.push({
		                    price: this.computePrice(entry.price),
		                    type: 'gift',
		                    currency: entry.currency || 'gold',
		                    infinite: entry.infinite,
	                    	scaling: entry.scaling
		                });
		            }
	                break;
	            }

	            default:
	                // Unknown type - no action
	                break;
	        }
	    });

		/*if (model.mystery)
			this.articles = this.articles.map(a => Object.assign({}, a, { value: mystery_articles[a.type], contains: a.value, mystery: true }));*/

		if (this.mezuri && this.run.champion.getPassive("mezuridiscount"))
			this.articles.forEach(a => a.price = Math.ceil(a.price * (100 - (this.run.champion.getPassive("mezuridiscount") || 0))/100));

	    this.run.notify('fillshop', this, this.articles);
	}

	applyDiscount (multiplier) {

		this.articles.forEach(article => {
			if (typeof article.price === "number" && !isNaN(article.price))
				article.price = Math.ceil(article.price * multiplier);
			if (typeof article.scaling === "number" && !isNaN(article.scaling))
				article.scaling = Math.ceil(article.scaling * multiplier);
		});
		this.run.notify('fillshop', this, this.articles);
	}

	buy (no) {

		if (no >= this.articles.length)
			return;
		let article = this.articles[no];
		if (article.unbuyable)
			return;
		if (article.type === "cleanse" && this.run.champion.curses.length === 0)
			return;
		let companionReroll = null;
		if (article.type === "switchcompanion") {
			const displayedCompanion = this.articles.find(a => a.type === "companion");
			const ownedCompanionKey = this.run.companion?.model.key;
			const displayedCompanionKey = displayedCompanion?.value.key;
			const possibilities = this.getLists().companions.filter(companion =>
				companion.key !== ownedCompanionKey && companion.key !== displayedCompanionKey
			);
			if (!displayedCompanion || displayedCompanion.sold || possibilities.length === 0)
				return;
			companionReroll = possibilities[Math.floor(Math.random() * possibilities.length)];
		}

		switch (article.currency || "gold") {
		case "health":
			if (article.sold || article.price > this.run.champion.hp)
				return;
			this.run.champion.loseLife(article.price);
			break;
		case "shard":
			return;
		case "exp":
			if (article.sold || article.price > this.run.champion.availableExp)
				return;
			this.run.champion.loseExp(article.price);
			break;
		case "corruption":
			this.run.champion.gainCorruption(article.price);
			break;
		case "paws":
			if (article.sold || article.price > this.run.paws)
				return;
			if (article.price > 0)
				this.run.addPaws(-article.price);
			break;
		default:
			if (article.sold || article.price > this.run.champion.gold)
				return;
			if (article.price > 0)
				this.run.champion.loseGold(article.price);
			break;
		}

		if (!article.infinite)
			article.sold = true;
		else if (article.infinite && article.scaling)
			article.price += article.scaling;

		let value = article.mystery ? article.contains : article.value;
		const buytype = article.type;

		switch (article.type) {
		case "health": this.run.champion.heal(value); break;
		case "card": this.run.addCard(value); break;
		case "potion": this.run.champion.newPotion(value); break;
		case "companion":
			this.run.companion = new Companion(this.run, value.key);
			this.articles.filter(a => a.type === "companion" || a.type === "switchcompanion").forEach(article => {
				article.price = null;
				article.currency = null;
				article.unbuyable = true;
			})
			break;
		case "switchcompanion":
			this.articles.find(a => a.type === "companion").value = companionReroll;
			break;
		case "relic": this.run.champion.newRelic(value); break;
		case "berry": this.run.champion.heal(this.run.berryHp); break;
		case "coin": this.run.champion.gainGold(this.run.coinGold); break;
		case "gold": this.run.champion.gainGold(value); break;
		case "paws": this.run.addPaws(1); break;
		case "insight": this.run.addInsight(value); break;
		case "special": this.runSlots(); break;
		case "remove": this.run.dropChoice(); this.run.removeCountShop++; break;
		case "cleanse": this.run.champion.cureRandomCurse(); break;
		case "seed": this.run.champion.gainExp(this.run.seedExp); if (this.mezuri) this.run.seedCountShop += this.run.floor; break;
		case "randompotion":
			let potions = Library.potions;
			potions = Object.values(potions).filter(potion => potion.rarity && (!potion.rank || this.run.power >= potion.rank) && (!potion.champion || potion.champion === this.run.champion.model.key || Array.isArray(potion.champion) && potion.champion.includes(this.run.champion.model.key)))
			let randompotion = null;
			while (!randompotion) {
				randompotion = potions[Math.floor(Math.random() * potions.length)];
				if (randompotion.rarity > 1 && Math.random() < 0.66)
					randompotion = null;
			}
			this.run.champion.newPotion(randompotion);
			break;
		case "gift":
			article.type = this.getRandomGift();
			if (article.type === "card" || article.type === "relic" || article.type === "potion") {
				let filteredList = this.getLists(true)[article.type + "s"].filter(item => !this.articles.some(a => a.type === article.type && a.value && a.value.key === item.key));
				article.value = filteredList[Math.floor(Math.random() * filteredList.length)];
				if (article.type === "card")
					article.value = this.run.getUpgradedCard(article.value);
			}
			article.price = 0;
			delete article.currency;
			delete article.sold;
			break;
		default: break;
		}

		if (this.single) 
			this.articles.filter(a => !a.sold).forEach(article => {
				article.sold = true;
				article.price = null;
				article.currency = null;
				article.unbuyable = true;
				delete this.single;
			})

		this.run.notify('shopbuy', this, no, buytype);
	}

	serialize () {

		return {
			articles: this.articles.slice(),
			mezuri: this.mezuri,
			single: this.single,
			slotMachine: this.slotMachine ? this.slotMachine.map(s => s) : undefined
		}
	}

	static build (run, src) {

		let shop = new Shop(run);
		shop.mezuri = src.mezuri;
		shop.articles = src.articles.filter(article => article.type !== "shards" && article.currency !== "shard");
		shop.single = src.single;
		shop.slotMachine = src.slotMachine ? src.slotMachine.map(slot => slot === "shards" ? "coin" : slot) : undefined;
		return shop;
	}
}
